import { AdRequestFormatTemplate } from './ad-request-format-template.model';
import { AdRequestParameterTemplate } from './ad-request-parameter-template.model';
import {
  AdRequestParameter
} from './ad-request-parameter.model';
import { ApiBind, Common } from './common.model';
import { Placement } from './placement.model';
import { Platform } from './platform.model';

/**
 * 広告リクエストを表すクラス.
 *
 * @class
 * @extends Common
 */
export class AdRequest extends Common {
  @ApiBind({ column: 'id' })
  id: number;

  @ApiBind({ column: 'name' })
  name: string;

  @ApiBind({ column: 'ad_format' })
  adFormat: number;

  @ApiBind({ column: 'placement', model: (value) => new Placement(value) })
  placement: Placement;

  @ApiBind({ column: 'platform', model: (value) => new Platform(value) })
  platform: Platform;

  @ApiBind({
    column: 'ad_request_format_template',
    model: (value) => new AdRequestFormatTemplate(value),
  })
  adRequestFormatTemplate: AdRequestFormatTemplate;

  @ApiBind({
    column: 'ad_request_parameter_template',
    model: (value) => new AdRequestParameterTemplate(value),
  })
  adRequestParameterTemplate?: AdRequestParameterTemplate;

  @ApiBind({
    column: 'ad_request_parameters',
    model: (values) => values.map((value) => new AdRequestParameter(value)),
  })
  adRequestParameters: AdRequestParameter[];

  @ApiBind({ column: 'platform_frame_name' })
  platformFrameName: string;

  @ApiBind({ column: 'memo' })
  memo: string;

  @ApiBind({ column: 'updated_at' })
  updatedAt: string;

  /**
   * 削除のAPIに送信するJSONに変換し返却する.
   *
   * @returns `id`と`updated_at`のプロパティが存在するオブジェクト
   */
  public toDeleteItemJSON() {
    return {
      id: this.convertJSONObject(this.id),
      updated_at: this.convertJSONObject(this.updatedAt),
    };
  }
}
